import React, { useEffect, useState } from "react";
import { coachScreenOpen } from "../Simplify360Chat/Services/HWIframeBridge";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";
import HelpAssistant from "./HelpAssistant/HelpAssistant";

const Simplify360Tatasky = (props) => {
  const [idleTime, setIdleTime] = useState(false);
  const [name, setName] = useState();
  const [login, setLogin] = useState(false);
  const [loginLoader, setLoginLoader] = useState(true);
  const [loginCount, setLoginCount] = useState(0);

  window.addEventListener("message", function (event) {});
  const isConfigured = s360ConfigService.isConfigured();

  useEffect(() => {
    coachScreenOpen();
    localStorage.removeItem("linkChatOnce");
    localStorage.removeItem("linkLoginOnce");
  }, []);

  useEffect(() => {
    setLoginCount(props.loginCount);
  }, [props]);

  return (
    <>
      {isConfigured ? (
        <>
          <HelpAssistant
            loginCount={loginCount}
            idleTime={idleTime}
            name={name}
            login={login}
            loginLoader={loginLoader}
            authenticated={props.authenticated}
            action={props.action}
            userDetails={props?.userDetails}
            {...props}
          />
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Simplify360Tatasky;
